module.exports = __webpack_public_path__ + "static/dawid-52238771a8b03ff413947d35c67cdaac.jpg";